import { stickLeft, stickRight } from '../constants';

export interface RenderWord {
    char: string;
    jyutping: string;
    yale: string;
    gloss: string;
    directive: string;
    [field: string]: string;
}

/** Parse editable word records without losing unmatched opening punctuation. */
const prepareWords = (input: string, stickyPunctuation = false): RenderWord[] => {
    const words: RenderWord[] = [];
    let opening = '';
    input.split(/\r?\n/).filter((line) => line.trim()).forEach((line) => {
        let [char = '', jyutping = '', yale = '', gloss = ''] = line.split('|');
        const directive = /\(.*\)/.test(char) ? '()' : '';
        if (directive) char = char.replace(/[()]/g, '');
        if (stickyPunctuation && stickRight.includes(char)) {
            opening += char;
        } else if (stickyPunctuation && stickLeft.includes(char) && words.length > 0 && !opening) {
            words[words.length - 1].char += char;
        } else {
            words.push({ char: opening + char, jyutping, yale, gloss, directive });
            opening = '';
        }
    });
    if (opening) words.push({ char: opening, jyutping: '', yale: '', gloss: '', directive: '' });
    return words;
};

export default prepareWords;
